import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  letter: PropTypes.string.isRequired
};

const Avatar = ({ letter }) => {
  return (
    <div className="avatar" tabIndex={0} role="menu">
      <button className="avatar--content" type="button">
        <span>{letter}</span>
      </button>
    </div>
  );
};

Avatar.propTypes = propTypes;

export default Avatar;
